import React from "react";
import { CLIENTS } from "../data/siteData";

export function Clients() {
  const client = CLIENTS[0]; // Star Aerospace client data

  return (
    <div className="page-bg clients-bg">
      <div className="page-overlay">
        {/* Hero Section */}
        <div className="clients-hero bg-dark text-white py-5">
          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <div className="mb-3">
                  <i
                    className="bi bi-people-fill text-warning"
                    style={{ fontSize: "3rem" }}
                  ></i>
                </div>
                <h1 className="display-4 fw-bold mb-3">Our Clients</h1>
                <p className="lead mb-0">
                  Trusted by innovative companies across defense and technology
                  sectors
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Featured Client - Star Aerospace */}
        <div className="featured-client-section py-5">
          <div className="container py-4">
            <div className="text-center mb-5">
              <span className="badge bg-warning text-dark mb-3 px-3 py-2">
                <i className="bi bi-star-fill me-2"></i>
                Featured Client
              </span>
              <h2 className="fw-bold display-6 mb-3">{client.name}</h2>
              <p className="text-muted lead">
                <i className="bi bi-award me-2"></i>
                Defense & Aerospace Technology Leader
              </p>
            </div>

            {/* Client Overview */}
            <div className="row mb-5">
              <div className="col-lg-10 mx-auto">
                <div className="client-overview card border-0 shadow-sm">
                  <div className="card-body p-4 p-lg-5">
                    <div className="row g-4 mb-4">
                      <div className="col-md-4">
                        <div className="client-info-item text-center">
                          <div
                            className="info-icon-box bg-warning bg-opacity-10 rounded-3 d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "60px", height: "60px" }}
                          >
                            <i className="bi bi-building text-warning fs-4"></i>
                          </div>
                          <h6 className="fw-semibold mb-2">Industry</h6>
                          <p className="text-muted small mb-0">
                            {client.industry}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="client-info-item text-center">
                          <div
                            className="info-icon-box bg-warning bg-opacity-10 rounded-3 d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "60px", height: "60px" }}
                          >
                            <i className="bi bi-geo-alt-fill text-warning fs-4"></i>
                          </div>
                          <h6 className="fw-semibold mb-2">Location</h6>
                          <p className="text-muted small mb-0">
                            {client.location}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="client-info-item text-center">
                          <div
                            className="info-icon-box bg-warning bg-opacity-10 rounded-3 d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "60px", height: "60px" }}
                          >
                            <i className="bi bi-globe text-warning fs-4"></i>
                          </div>
                          <h6 className="fw-semibold mb-2">Website</h6>
                          <a
                            href={client.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-warning small text-decoration-none d-inline-flex align-items-center"
                          >
                            staraerospace.org
                            <i className="bi bi-box-arrow-up-right ms-2"></i>
                          </a>
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    <div className="client-description mb-4">
                      <h5 className="fw-bold mb-3">
                        <i className="bi bi-info-circle-fill text-warning me-2"></i>
                        About Star Aerospace
                      </h5>
                      <p className="text-muted">{client.description}</p>
                    </div>

                    <div className="client-mission bg-light rounded-3 p-4">
                      <div className="row">
                        <div className="col-md-6 mb-3 mb-md-0">
                          <h6 className="fw-bold mb-3">
                            <i className="bi bi-bullseye text-warning me-2"></i>
                            Mission
                          </h6>
                          <p className="small text-muted mb-0">
                            To establish itself as a leading manufacturer in the
                            defense industry and emerge as a world-class
                            sophisticated, state-of-the-art global enterprise.
                          </p>
                        </div>
                        <div className="col-md-6">
                          <h6 className="fw-bold mb-3">
                            <i className="bi bi-eye-fill text-warning me-2"></i>
                            Vision
                          </h6>
                          <p className="small text-muted mb-0">
                            To be a world-class enterprise, producing
                            international standard quality products for the
                            defense industry.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Project Details */}
            {/* <div className="row g-4 mb-5">
              <div className="col-lg-6">
                <div className="card border-0 shadow-sm h-100 challenge-card">
                  <div className="card-body p-4 p-lg-5">
                    <div className="challenge-icon mb-4">
                      <div
                        className="icon-circle bg-danger bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-3"
                        style={{ width: "60px", height: "60px" }}
                      >
                        <i className="bi bi-exclamation-triangle text-danger fs-3"></i>
                      </div>
                    </div>
                    <h4 className="fw-bold mb-4">The Challenge</h4>
                    <p className="text-muted mb-0">{client.challenge}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card border-0 shadow-sm h-100 solution-card">
                  <div className="card-body p-4 p-lg-5">
                    <div className="solution-icon mb-4">
                      <div
                        className="icon-circle bg-success bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-3"
                        style={{ width: "60px", height: "60px" }}
                      >
                        <i className="bi bi-lightbulb text-success fs-3"></i>
                      </div>
                    </div>
                    <h4 className="fw-bold mb-4">Our Solution</h4>
                    <p className="text-muted mb-0">{client.solution}</p>
                  </div>
                </div>
              </div>
            </div> */}

            {/* Technologies Used - Only if technologies array exists */}
            {client.technologies && client.technologies.length > 0 && (
              <div className="row mb-5">
                <div className="col-lg-10 mx-auto">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body p-4 p-lg-5">
                      <h4 className="fw-bold mb-4 text-center">
                        <i className="bi bi-stack text-warning me-2"></i>
                        Technologies Used
                      </h4>
                      <div className="d-flex flex-wrap justify-content-center gap-3">
                        {client.technologies.map((tech, idx) => (
                          <span
                            key={idx}
                            className="badge bg-dark fs-6 px-4 py-2 d-inline-flex align-items-center"
                          >
                            <i className="bi bi-check-circle me-2"></i>
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Testimonial */}
            {/* <div className="row">
              <div className="col-lg-10 mx-auto">
                <div className="testimonial-card card border-0 shadow-lg">
                  <div className="card-body p-4 p-lg-5 text-center">
                    <div className="quote-icon mb-4">
                      <i
                        className="bi bi-quote text-warning"
                        style={{ fontSize: "4rem", opacity: 0.3 }}
                      ></i>
                    </div>
                    <p
                      className="lead mb-4 fst-italic text-muted"
                      style={{ fontSize: "1.25rem" }}
                    >
                      "{client.testimonial.quote}"
                    </p>
                    <div className="testimonial-author mt-4 pt-4 border-top">
                      <div className="author-icon mb-3">
                        <i className="bi bi-person-circle text-warning fs-1"></i>
                      </div>
                      <p className="fw-bold mb-1 fs-5">
                        {client.testimonial.author}
                      </p>
                      <p className="text-muted small mb-0">
                        <i className="bi bi-briefcase me-2"></i>
                        {client.testimonial.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* CTA Section */}
      </div>
    </div>
  );
}
